// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Index from './pages';
import Vehicle from './pages/Vehicle';
import Vehicledetails from './pages/VehicleDetails';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="Vehicles" element={<Vehicle />} />
        <Route path="vehcile-details" element={<Vehicledetails />} />
      </Routes>
    </Router>
  );
}

export default App;
